import { getObjectModule, ObjectsType } from './get.module';

const module = getObjectModule(ObjectsType.Bodies);
export default module;
